import { Component, inject, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../../components/button/button.component';
import TYPES from '../../constants/types';
import { ActivatedRoute, Router } from '@angular/router';
import { InviteService } from '../../services/invite.service';
import { Invite } from '../../models/invite';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import { LoadingComponent } from '../../components/loading/loading.component';

@Component({
  selector: 'app-accept-invite',
  imports: [
    LoadingComponent,
    ButtonComponent,
    TranslatePipe
  ],
  templateUrl: './accept-invite.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './accept-invite.component.scss',
})
export class AcceptInviteComponent {

  inviteService: InviteService<Invite> = inject(InviteService<Invite>);
  authService: AuthService = inject(AUTH_SERVICE);
  loading: WritableSignal<boolean> = signal<boolean>(true);

  BUTTON_TYPES: any;
  token: string;

  invite: WritableSignal<Invite | null> = signal<Invite | null>(null);

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.token = this.route.snapshot.paramMap.get('token')!;
    this.BUTTON_TYPES = TYPES.UI.BUTTON;

    this.loading.set(true);
    this.inviteService.getByToken(this.token).then(
      (inviteReturned: Invite) => {
        this.invite.set(inviteReturned);
        this.loading.set(false);
    });

  }

  async accept(){
    localStorage.setItem('inviteToken', this.token);

    if(await this.authService.isLoggedIn()){
      this.router.navigate(['/home']);
    }else{
      this.router.navigate(['/login'], {queryParams: {inviteEmail: this.invite()?.email}});
    }
  }

  continue(){
    window.location.replace('/home');
  }

  isInviteValid(invite: Invite | null): boolean {
    if(invite){
      if (!invite.expires_at) return false;

      const expiresDate = new Date(invite.expires_at);

      if (isNaN(expiresDate.getTime())) {
        console.warn('expires_at inválido:', invite.expires_at);
        return false;
      }

      return expiresDate >= new Date() && invite.status === TYPES.DATABASE.STATUS.PENDING.code;
    }else{
      return false;
    }
  }

}
